export default __webpack_public_path__ + "static/reaction_types-e2e5467fa1f8a80ee79a07d97562892d.png";